import { defineStore } from "pinia";
import { TagsResponse } from "~/entities/TagsResponse";
import type { UserTagTypeResponse } from "~/entities/UserTagTypeResponse";
import { type ITagRepository } from "~/interfaces/ITagRepository";
import { TagRepository } from "~/repositories/TagRepository";

export const useTagStore = defineStore("TagStore", () => {
  const repository: ITagRepository = new TagRepository();
  const tags = ref<TagsResponse>();
  const userTagTypes = ref<UserTagTypeResponse>();
  const loading = ref(false);

  const fetch = async () => {
    loading.value = true;
    try {
      tags.value = await repository.fetch();
    } finally {
      loading.value = false;
    }
  };

  const fetchUserTagTypes = async (options: Record<string, string>) => {
    loading.value = true;
    try {
      userTagTypes.value = await repository.fetchUserTagTypes(options);
    } finally {
      loading.value = false;
    }
  };

  return {
    tags,
    userTagTypes,
    loading,
    fetch,
    fetchUserTagTypes,
  };
});
